import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center self-center" }
const _hoisted_2 = { class: "p-12 bg-white mx-auto rounded-2xl w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-2xl text-gray-800" }, "Sign In")
], -1)
const _hoisted_4 = { class: "space-y-5" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-medium text-slate-700 tracking-wide" }, "Email", -1)
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "mb-5 text-sm font-medium text-gray-700 tracking-wide" }, " Password ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, null, -1)
const _hoisted_10 = {
  key: 0,
  role: "alert",
  class: "alert alert-error text-base"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "stroke-current shrink-0 h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)

import { ref, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  props: {
  errorMessage: String,
},
  emits: ["signIn"],
  setup(__props, { emit: __emit }) {

const email = ref("");
const password = ref("");

const userPayload = computed(() => {
  return { email: email.value, password: password.value };
});

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            class: "input w-full max-w-xs text-neutral-content bg-black",
            type: "",
            placeholder: "Enter your email"
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            class: "input w-full max-w-xs text-neutral-content bg-black",
            type: "password",
            placeholder: "Enter your password"
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('signIn', userPayload.value))),
            class: "w-full flex justify-center bg-[#0b295b] text-gray-100 p-3 rounded-full tracking-wide font-semibold shadow-lg cursor-pointer"
          }, " Sign in ")
        ]),
        _createVNode(_Transition, {
          "enter-from-class": "translate-x-[150%] opacity-0",
          "enter-active-class": "transition duration-300"
        }, {
          default: _withCtx(() => [
            (props.errorMessage?.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(__props.errorMessage), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})